



















































































































import { Prop } from 'vue-property-decorator';
import HuntingLicenseOrderForm from '@/modules/HuntingLicenses/LicenseOrder/Form.vue';
import Component, { mixins } from 'vue-class-component';
import { AxiosPromise } from 'axios';
import { CATALOGS_SEASONS, CATALOGS_ZONES, HUNTING_LICENSE_ORDERS } from '@/common/api';
import UseBackend from '@/core/mixins/use-backend';
import StatusChip from '@/shared_components/StatusChip.vue';
import { statusApplication } from '@/common/constants';
import { saveFileFromResponse } from '@/common/helpers';
import PaymentForm from '@/modules/HuntingLicenses/LicenseOrder/PaymentForm.vue';
import ModalRejectOrderAttachments from '@/shared_components/ModalRejectOrderAttachments.vue';
import HuntingLicenseOrderStepper from '@/modules/HuntingLicenses/LicenseOrder/ShowWrapper.vue';
import HuntingLicenseForm from './HuntingLicenseForm.vue';
import HuntingLicenseOrderFull = Orders.HuntingLicenseOrderFull;
import PaymentDetails = Orders.PaymentDetails;
import HuntingLicenseOrderCharges from '@/modules/HuntingLicenses/LicenseOrder/HuntingLicenseOrderCharges.vue';

// eslint-disable-next-line no-use-before-define
@Component<ShowOrder>({
  components: {
    HuntingLicenseOrderCharges,
    HuntingLicenseOrderForm,
    StatusChip,
    ModalRejectOrderAttachments,
    HuntingLicenseForm,
    PaymentForm,
    HuntingLicenseOrderStepper,
  },
})
export default class ShowOrder extends mixins(UseBackend) {
  @Prop({
    type: [String, Number],
    required: true,
  })
  orderId!: string;

  referrer: any = null;

  modalVisibilityReject: boolean = false;

  value: null | HuntingLicenseOrderFull = null;

  statusApplication = statusApplication;

  modalVisibilityIssue: boolean = false;

  modalVisibilityPayment: boolean = false;

  paymentData: PaymentDetails = {
    duty: 0,
    tax: 0,
  };

  seasons: Array<Orders.Season> = [];

  zones: Array<Orders.Zone> = [];

  get isCompleted(): boolean {
    return (
      this.value !== null &&
      this.value.huntingLicense !== null &&
      this.value.statusApplicationId === statusApplication.SERVICE_PROVIDE.id
    );
  }

  get canBeTaken(): boolean {
    if (this.value?.userId === this.$currentUser.id) {
      return false;
    }
    return !([
      statusApplication.CANCEL.id,
      statusApplication.DENIED.id,
      statusApplication.SERVICE_PROVIDE.id,
    ] as Array<any>).includes(this.value?.statusApplicationId);
  }

  get doesNotHaveIssue(): boolean {
    return this.value !== null && this.value?.huntingLicense === null;
  }

  get personFio(): string {
    return [this.value?.lastname, this.value?.firstname, this.value?.middlename]
      .filter(s => s)
      .join(' ');
  }

  async mounted(): Promise<void> {
    await this.refresh();
  }

  async refresh() {
    [
      { data: this.value },
      {
        data: { data: this.seasons },
      },
      {
        data: { data: this.zones },
      },
    ] = await this.makeRequest(() =>
      Promise.all([
        this.$http({
          ...HUNTING_LICENSE_ORDERS.GET(+this.orderId),
        }),
        this.$http({ ...CATALOGS_SEASONS.LIST, params: { onlyActive: true } }),
        this.$http(CATALOGS_ZONES.LIST),
      ]),
    );

    // onlyActive drops ended seasons, so a saved closed season is missing from options
    // and q-select renders "undefined" instead of its name.
    const currentSeason = this.value?.season;
    if (currentSeason && !this.seasons.some(season => season.id === currentSeason.id)) {
      this.seasons = [currentSeason, ...this.seasons];
    }
  }

  toList() {
    if (this.referrer !== null && ['hunting-licenses-order-list'].includes(this.referrer.name)) {
      this.$router.push(this.referrer);
      return;
    }

    this.$router.push({ name: 'hunting-licenses-order-list' });
  }

  // eslint-disable-next-line class-methods-use-this
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // eslint-disable-next-line no-param-reassign
      vm.referrer = from;
    });
  }

  async takeToWork() {
    const endpoint = HUNTING_LICENSE_ORDERS.TAKE_TO_WORK(+this.orderId);
    ({ data: this.value } = await this.makeRequest(() => this.$http(endpoint)));
  }

  async issueLicense(data) {
    const rejectOrderId = +this.orderId;
    const endpoint = HUNTING_LICENSE_ORDERS.ISSUE_LICENSE(rejectOrderId);
    await this.makeRequest(() => this.$http({ ...endpoint, data }));
    this.modalVisibilityIssue = false;
    await this.refresh();
  }

  async printHuntingLicense() {
    if (!this.value) return;
    const request = () =>
      this.$http({
        ...HUNTING_LICENSE_ORDERS.PRINT_PERMISSION(
          (this.value as Orders.HuntingLicenseOrderFull).id,
        ),
        responseType: 'blob',
      });

    saveFileFromResponse(await this.makeRequest(request));
  }

  async printApplication() {
    if (!this.value) return;
    const request = () =>
      this.$http({
        ...HUNTING_LICENSE_ORDERS.PRINT_ISSUE(
          (this.value as Orders.HuntingLicenseOrderFull).id,
        ),
        responseType: 'blob',
      });

    saveFileFromResponse(await this.makeRequest(request));
  }

  async rejectOrder(reject) {
    const rejectOrderId = +this.orderId;
    const endpoint = HUNTING_LICENSE_ORDERS.REJECT(rejectOrderId);
    await this.makeRequest(() => this.$http({ ...endpoint, data: reject }));
    this.modalVisibilityReject = false;
    await this.refresh();
  }

  beforeDestroy(): void {
    this.modalVisibilityIssue = false;
    this.modalVisibilityReject = false;
  }

  async checkPaymentDocs(): Promise<void> {
    const response = await this.paymentDocsRequest(true);
    if (response) {
      this.paymentData = response;
      this.modalVisibilityPayment = true;
    }
  }

  async sendPaymentDocs(message: string, paymentDetails: PaymentDetails): Promise<void> {
    await this.paymentDocsRequest(false, message, paymentDetails);
    this.modalVisibilityPayment = false;
    this.$s.notify.success('Квитанция отправлена в ЛК ЕПГУ заявителя');
  }

  async paymentDocsRequest(
    pretend: boolean,
    message: string = '',
    paymentDetails?: PaymentDetails,
  ): Promise<void | PaymentDetails> {
    const data: any = { pretend, message };
    if (paymentDetails) {
      data.totalAnimalPrice = paymentDetails.tax || 0;
    }
    const { data: responseData } = await this.makeRequest(
      () =>
        this.$http({
          ...HUNTING_LICENSE_ORDERS.SEND_PAYMENT_DOCS(+this.orderId),
          data,
        }) as AxiosPromise<void | PaymentDetails>,
    );
    return responseData;
  }
}
